var _slicedToArray = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/slicedToArray");

var _taggedTemplateLiteral = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

module.exports = function (e) {
  var t = {};

  function r(o) {
    if (t[o]) return t[o].exports;
    var n = t[o] = {
      i: o,
      l: !1,
      exports: {}
    };
    return e[o].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, o) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: o
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var o = Object.create(null);
    if (r.r(o), Object.defineProperty(o, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var n in e) {
      r.d(o, n, function (t) {
        return e[t];
      }.bind(null, n));
    }
    return o;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 72);
}({
  1: function _(e, t) {
    e.exports = require("react");
  },
  2: function _(e, t) {
    e.exports = require("styled-components");
  },
  3: function _(e, t) {
    e.exports = require("../../styles");
  },
  5: function _(e, t) {
    e.exports = require("../Icon/Icon");
  },
  72: function _(e, t, r) {
    "use strict";

    var o = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var r in e) {
        Object.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
      return t.default = e, t;
    },
        n = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = o(r(1)),
        s = n(r(2)),
        u = n(r(73)),
        i = n(r(74)),
        l = r(3),
        d = n(r(5)),
        c = l.colorPalettes.KineduPalette,
        f = s.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  .search-text {\n    input {\n      border-radius: 0px;\n      height: 48px;\n      border: none;\n    }\n  }\n\n  .search-btn {\n    display: none;\n    position: absolute;\n    right: 0;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  &.focused {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n\n    .search-text {\n      box-shadow: 0 1px 8px -6px;\n    }\n\n    .search-suggestions {\n      display: flex;\n    }\n  }\n\n  ", " {\n    .search-text {\n      input {\n        height: 40px;\n        border-radius: 20px;\n        border: 1px solid #ACC2D3;\n      }\n    }\n    .search-btn {\n      display: block;\n    }\n\n    .search-icon {\n      display: none;\n    }\n\n    &.focused {\n      position: relative;\n\n      .search-text {\n        box-shadow: none;\n\n        input {\n          border-radius: 0;\n          border-top-left-radius: 20px;\n          border-top-right-radius: 20px;\n\n          & + .texter-slot .search-btn {\n            border-radius: 0;\n            border-top-right-radius: 20px;\n          }\n        }\n      }\n\n      .search-suggestions {\n        display: flex;\n      }\n    }\n  }\n"])), l.breakPoints.desktop),
        p = s.default.div.attrs(function () {
      return {
        className: "row"
      };
    })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n\n  .search-icon {\n    margin-top: -5px;\n  }\n"]))),
        x = s.default(p)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\n  ", " {\n    z-index: 1;\n    position: absolute;\n    top: 100%;\n  }\n"])), l.breakPoints.desktop),
        b = s.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: none;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: -1;\n\n  padding-top: 70px;\n  width: 100%;\n  background-color: white;\n\n  ", " {\n    position: relative;\n    border-bottom-left-radius: 20px;\n    border-bottom-right-radius: 20px;\n    padding-top: 0px;\n    border: 1px solid ", ";\n    border-top: none;\n    box-shadow: 0 5px 10px 0 rgba(0,0,0,0.20);\n  }\n"])), l.breakPoints.desktop, c.shadeMedium);

    t.default = function (e) {
      var _e$onSearch = e.onSearch,
          t = _e$onSearch === void 0 ? function () {} : _e$onSearch,
          _e$placeholder = e.placeholder,
          r = _e$placeholder === void 0 ? "What are you looking for..." : _e$placeholder,
          _e$suggestionsSlot = e.suggestionsSlot,
          o = _e$suggestionsSlot === void 0 ? function () {
        return null;
      } : _e$suggestionsSlot,
          n = e.handleIsOpen,
          s = e.closeSearch,
          l = e.value,
          h = e.onChangeText,
          _e$buttonText = e.buttonText,
          m = _e$buttonText === void 0 ? "Search" : _e$buttonText,
          _a$useState = a.useState(l),
          _a$useState2 = _slicedToArray(_a$useState, 2),
          g = _a$useState2[0],
          v = _a$useState2[1],
          y = a.useRef(),
          _ = a.useRef();

      a.useEffect(function () {
        v(l);
      }, [l]);

      var w = function w() {
        y.current.classList.remove("focused"), n(!1);
      },
          E = function E(e) {
        y.current && !y.current.contains(e.target) && w();
      },
          S = function S() {
        t(_.current.value);
      };

      return a.useEffect(function () {
        return document.addEventListener("mousedown", E), function () {
          document.removeEventListener("mousedown", E);
        };
      }, []), a.useEffect(function () {
        s && w();
      }, [s]), a.default.createElement(f, {
        className: "lego-searcher",
        ref: y
      }, a.default.createElement(p, null, a.default.createElement(u.default, {
        getInputRef: function getInputRef(e) {
          _.current = e;
        },
        value: g,
        onChange: h,
        className: "search-text",
        theme: "RoundedFlat",
        name: "Search",
        placeholder: r,
        onFocus: function onFocus() {
          y.current.classList.add("focused"), n(!0);
        },
        rightSlot: function rightSlot() {
          return a.default.createElement(a.default.Fragment, null, a.default.createElement(i.default, {
            className: "search-btn",
            color: c.newKinedu,
            flat: !0,
            rounded: !0,
            small: !0,
            onClick: S
          }, m), a.default.createElement(d.default, {
            className: "search-icon",
            color: c.newKinedu,
            name: "lens",
            onClick: S,
            size: 30
          }));
        }
      })), a.default.createElement(x, null, a.default.createElement(b, {
        className: "search-suggestions"
      }, o())));
    };
  },
  73: function _(e, t) {
    e.exports = require("../Texter/Texter");
  },
  74: function _(e, t) {
    e.exports = require("../Button/Button");
  }
});